import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { push } from 'react-router-redux';
import { reduxForm, Field } from 'redux-form';

import { Link } from 'react-router-dom';
import validators from '../shared/validators';
import FormField from '../checkout-steps/shared/form-field';
import Layout from '../layout';

import stylesComingSoon from '../styles/pages/coming-soon.scss';
import APP_ROUTES from '../../constants/app-routes';

import styles from '../styles/pages/signin.scss';

import successImage from '../../images/success.png';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            passwordChangeSuccess: false,
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        document.title = this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Password' });
    }

    componentDidMount() {
        // Redirect to home if is authenticated
        if (this.props.user && this.props.user.id) {
            this.props.dispatch(push(APP_ROUTES.homePageRoute));
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Password' });
        }
    }

    handleFormSubmit(formData) {
        const { token } = this.props.match.params;
        this.props.submitForgotPassword(formData, token, this.props.locale.currentLocale).then(
            (resp) => {
                if (resp) {
                    this.setState({ passwordChangeSuccess: true });
                }
            },
        );
    }

    render() {
        const {
            handleSubmit, valid, submitting, intl,
        } = this.props;

        const { passwordChangeSuccess } = this.state;
        const passwordChangeMessage = (
            <div
                className={stylesComingSoon.comingContainer}
            >
                <div>
                    <div className="text-center" style={{ paddingBottom: 45 }}>
                        <img
                            style={{ maxWidth: '35%', height: 'auto' }}
                            src={successImage}
                            alt={this.props.intl.formatMessage({
                                id: 'not-found',
                                defaultMessage: 'Not',
                            })}
                        />
                    </div>
                </div>
                <h1
                    className={stylesComingSoon.mainText}
                >
                    <FormattedMessage
                        id="password-reset"
                        defaultMessage="Your password has been updated"
                    />
                </h1>
                <Link
                    to={APP_ROUTES.mercadoUnicoProducts}
                    className={stylesComingSoon.buttonLink}
                >
                    <FormattedMessage
                        id="coming-soon-button"
                        defaultMessage="See Mercado Unico Products"
                    />
                </Link>
                <Link
                    to={APP_ROUTES.signin}
                    className={stylesComingSoon.buttonLink}
                >
                    <FormattedMessage
                        id="signin"
                        defaultMessage="Sign In"
                    />
                </Link>
            </div>
        );

        const forgotPasswordForm = (
            <main className={`content ${styles.signin}`}>
                <div className={`container ${styles.bodyContainer}`}>
                    <section>
                        <p className={styles.titlePage}>
                            <FormattedMessage id="forgot-password" defaultMessage="Forgot Password" />
                        </p>
                        <div className="row">
                            <div className="col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12">
                                <form className={styles.form} onSubmit={handleSubmit(this.handleFormSubmit)}>
                                    <div>
                                        <div className={`form-group ${styles.formGroup}`}>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 holder">
                                                <Field
                                                    className={styles.formInput}
                                                    name="user[password]"
                                                    component={FormField.inputFieldMarkup}
                                                    autoComplete="off"
                                                    type="password"
                                                    validate={[validators.required]}
                                                    placeholder={intl.formatMessage({
                                                        id: 'password',
                                                        defaultMessage: 'Password',
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        <div className={`form-group ${styles.formGroup}`}>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 holder">
                                                <Field
                                                    className={styles.formInput}
                                                    name="user[password_confirmation]"
                                                    component={FormField.inputFieldMarkup}
                                                    autoComplete="off"
                                                    type="password"
                                                    validate={[validators.required, validators.passwordConfirmation]}
                                                    placeholder={intl.formatMessage({
                                                        id: 'confirmPassword',
                                                        defaultMessage: 'Confirm Password',
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        <span hidden={[validators.passwordConfirmation]} className={styles.fieldError}>
                                            <FormattedMessage id="error-password-not-match" defaultMessage="Passwords do not match" />
                                        </span>
                                    </div>
                                    <div className={`form-group ${styles.formGroupHolder}`}>
                                        <button className="form-control btn btn-default" type="submit" disabled={!valid || submitting}>
                                            <span>
                                                <FormattedMessage id="send" defaultMessage="Send" />
                                            </span>
                                        </button>
                                    </div>
                                    <div className="form-legend">
                                        <FormattedMessage id="legend-required-field" defaultMessage="* indicates the field is required" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        );

        return (
            <Layout>

                {passwordChangeSuccess ? (
                    passwordChangeMessage
                ) : (
                    forgotPasswordForm
                )}

            </Layout>
        );
    }
}

ForgotPassword = reduxForm({
    form: 'forgotPassword',
})(ForgotPassword);

export default injectIntl(ForgotPassword);



/** WEBPACK FOOTER **
 ** ./src/components/pages/forgot-password.jsx
 **/